import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTestEmailSettings extends Layout {
    textboxCC: Textbox;
    textboxFrom: Textbox;
    textboxMessage: Textbox;
    textboxSubject: Textbox;
    textboxTo: Textbox;
}
